import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'op-page-header-search',
    templateUrl: './page-header-search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderSearchComponent {

}